import "core-js/modules/es6.array.map";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import styled from 'styled-components';
import RedBulletList from '../list/RedBulletList';
import { typography } from '../../style/theme';
import { getFontSize } from '../../utils/helpers';
var List = styled(RedBulletList).attrs({
  bold: true
}).withConfig({
  displayName: "Bullets__List",
  componentId: "sc-9mymbr-0"
})(["", " color:", ";"], getFontSize(typography.medium), function (_ref) {
  var theme = _ref.theme;
  return theme.color || null;
});

var USPBullets = function USPBullets(_ref) {
  var bullets = _ref.bullets,
      props = _objectWithoutProperties(_ref, ["bullets"]);

  if (bullets.length) {
    return React.createElement(List, props, bullets.map(function (bullet, index) {
      return React.createElement("li", {
        key: index
      }, bullet);
    }));
  }

  return null;
};

export default USPBullets;